import { Spinner } from './Spinner';
import type { ButtonHTMLAttributes } from 'react';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'danger' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  loading?: boolean;
}

const variants: Record<string, string> = {
  primary:
    'bg-gradient-to-b from-primary to-primary-hover text-white shadow-sm shadow-primary/25 hover:brightness-105 active:scale-[.98] disabled:from-gray-400 disabled:to-gray-400 disabled:shadow-none disabled:brightness-100',
  secondary:
    'bg-white text-gray-700 border border-gray-200 shadow-sm shadow-slate-200/50 hover:bg-gray-50 hover:border-gray-300 active:scale-[.98] disabled:bg-gray-100 disabled:shadow-none',
  danger:
    'bg-white text-danger border border-danger/30 hover:bg-danger-light hover:border-danger/40 active:scale-[.98] disabled:bg-gray-100',
  ghost:
    'bg-transparent text-gray-600 hover:bg-gray-100 active:scale-[.98] disabled:text-gray-500',
};

const sizes: Record<string, string> = {
  sm: 'px-3 py-1.5 text-xs',
  md: 'px-4 py-2 text-sm',
  lg: 'px-6 py-2.5 text-base',
};

export function Button({
  variant = 'primary',
  size = 'md',
  loading = false,
  disabled,
  children,
  className = '',
  ...props
}: ButtonProps) {
  return (
    <button
      disabled={disabled || loading}
      className={`inline-flex items-center justify-center gap-2 font-medium rounded-xl transition duration-150 cursor-pointer disabled:cursor-not-allowed disabled:active:scale-100 ${variants[variant]} ${sizes[size]} ${className}`}
      {...props}
    >
      {loading && <Spinner size="sm" />}
      {children}
    </button>
  );
}
